var $ = require('jquery');

if (window.name !== 'c') {
  window.name = 'NG_DEFER_BOOTSTRAP!';
}

require.ensure(
  ['./global/app-rebuild'],
  function(require) {
    var module = require('./global/app-rebuild');
    $(document).ready(function() {
      module.initialise();
    });
  },
  'inxpress.global.app'
);



// WEBPACK FOOTER //
// ./sitefiles/scripts/main-global-rebuild.js